import React, { useEffect, useState } from 'react';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';
import axiosInstance from 'apis/axiosConfig';

const EmiWalletList = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentLoan, setCurrentLoan] = useState(null);

    const fetchData = async () => {
        try {
            const res = await axiosInstance.get('loans-data');
            // Show only active loans where EMI needs to be collected
            const activeLoans = res.data.filter(loan => loan.loan_status === 'active');
            setData(activeLoans);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleActionClick = (row) => {
        setCurrentLoan(row);
        setShowModal(true);
    };

    const handleMarkPaid = async () => {
        if(currentLoan.remaining_emi_count <= 0) {
            toast.error("All EMIs are already paid for this loan!");
            return;
        }
        
        const newPaidCount = parseInt(currentLoan.emi_paid_count) + 1;
        const newRemCount = parseInt(currentLoan.remaining_emi_count) - 1;
        const newRemAmount = parseFloat(currentLoan.remaining_amount) - parseFloat(currentLoan.monthly_emi);

        // Auto complete loan if 0 remaining
        const newStatus = newRemCount <= 0 ? 'completed' : currentLoan.loan_status;

        try {
            await axiosInstance.put(`loans-data/${currentLoan.id}`, {
                emi_paid_count: newPaidCount,
                remaining_emi_count: newRemCount,
                remaining_amount: newRemAmount > 0 ? newRemAmount : 0,
                loan_status: newStatus
            });
            toast.success(`₹${currentLoan.monthly_emi} EMI Collected Successfully!`);
            setShowModal(false);
            fetchData();
        } catch (err) {
            toast.error("Failed to collect EMI");
        }
    };

    const getLoanFrequencyData = (row) => {
        const paidCount = parseInt(row.emi_paid_count || 0);
        const remCount = parseInt(row.remaining_emi_count || 0);
        const rawTenure = parseInt(row.loan_tenure_months || 12);

        let totalTenure = row.total_tenure_count || (paidCount + remCount) || rawTenure;
        let emiLabel = row.emi_frequency ? `${row.emi_frequency} EMI` : "Monthly EMI";

        return { emiLabel, totalTenure };
    };

    const tableHeaders = [
        { Header: 'Loan ID', accessor: 'id' },
        { Header: 'User ID', accessor: 'loan_user_id' },
        { 
            Header: 'EMI Amount', 
            accessor: 'monthly_emi', 
            Cell: ({ row }) => {
                const { emiLabel } = getLoanFrequencyData(row.original);
                return (
                    <div className="d-flex flex-column">
                        <small className="text-muted" style={{fontSize: '10px'}}>{emiLabel}</small>
                        <strong className="text-primary">₹{row.original.monthly_emi}</strong>
                    </div>
                )
            }
        },
        { Header: 'Paid EMIs', accessor: 'emi_paid_count', Cell: ({ row }) => <span className="text-success font-weight-bold">{row.original.emi_paid_count}</span> },
        { 
            Header: 'EMI Progress', 
            accessor: 'remaining_emi_count', 
            Cell: ({ row }) => {
                const { totalTenure } = getLoanFrequencyData(row.original);
                return <span className="text-primary font-weight-bold">{row.original.emi_paid_count}/{totalTenure}</span>
            }
        },
        { Header: 'Rem. Amount', accessor: 'remaining_amount', Cell: ({ row }) => `₹${row.original.remaining_amount}` },
        { Header: 'Action', accessor: 'action', Cell: ({ row }) => (<button className="btn btn-success btn-sm font-weight-bold" onClick={() => handleActionClick(row.original)}><i className="fa fa-inr"></i> Collect EMI</button>) }
    ];

    return (
        <div className='container-fluid mt-5'>
            <div className='mainheadig mx-4 d-flex'>
                <h4 className='text-white font-weight-bold'>EMI & Wallet Collections</h4>
            </div>
            {data?.length > 0 ? (
                <AdminTable tableHeaders={tableHeaders} tableData={data} />
            ) : <p className='container-fluid bg-info w-100 p-2 mx-4 text-center text-white'>No Active Loans available for EMI Collection</p>}

            {/* Collect EMI Modal */}
            {showModal && currentLoan && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-success text-white">
                                <h5 className="modal-title font-weight-bold">Collect EMI Payment</h5>
                                <button type="button" className="close text-white" onClick={() => setShowModal(false)}>&times;</button>
                            </div>
                            <div className="modal-body row">
                                <div className="col-12 mb-3 text-center">
                                    <h1 className="text-primary font-weight-bold">₹{currentLoan.monthly_emi}</h1>
                                    <p className="text-muted">EMI Amount to be Collected</p>
                                </div>
                                <div className="col-6 mb-2"><strong>Total Paid EMIs:</strong> {currentLoan.emi_paid_count}</div>
                                <div className="col-6 mb-2 text-danger"><strong>Remaining EMIs:</strong> {currentLoan.remaining_emi_count}/{getLoanFrequencyData(currentLoan).totalTenure}</div>
                                <div className="col-12 mt-3">
                                    <div className="alert alert-warning border-warning">
                                        <strong>Confirm Action:</strong> Clicking &quot;Confirm &amp; Mark as Paid&quot; will register 1 EMI as paid and reduce the remaining amount. This action is irreversible.
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                                <button type="button" className="btn btn-success font-weight-bold" onClick={handleMarkPaid}>Confirm & Mark as Paid</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
export default EmiWalletList;
